export default __webpack_public_path__ + "static/media/module3.96b8f0fe.jfif";